import { render, staticRenderFns } from "./ReservationCancels.vue?vue&type=template&id=6f7920f8&scoped=true&"
import script from "./ReservationCancels.vue?vue&type=script&lang=js&"
export * from "./ReservationCancels.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCancels.vue?vue&type=style&index=0&id=6f7920f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7920f8",
  null
  
)

export default component.exports